
jQuery(document).ready(function($){


  $('.slick-rankings').each(function (idx, item) {
    var carouselId = "carousel" + idx;
    this.id = carouselId;
    $(this).not('.slick-initialized').slick({
       
        centerMode: true,
        slidesToShow: 3,
        arrows: false,
        swipeToSlide: true,
        focusOnSelect: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 1
            }
          },
          
        ]
        
    });
});


  $('.slick-profiles').each(function (idx, item) {
    var carouselId = "carousel" + idx;
    this.id = carouselId;
    $(this).not('.slick-initialized').slick({
       
        centerMode: true,
        slidesToShow: 4,
        arrows: false,
        swipeToSlide: true,
        focusOnSelect: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 1
            }
          },
          
        ]
        
    });

});


  /* About Overview history of Broad slider */ 

  
  $('.timeLine-slider').not('.slick-initialized').slick({

   centerMode: true,
  slidesToShow: 3,
  arrows: false,
  focusOnSelect: true,
  swipeToSlide: true,
  
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 1
      }
    },
    
  ]
  
  });


/* Department and Program Page student testimonials slider */
$('.slick-testimonials').not('.slick-initialized').slick({
 centerMode: true,
slidesToShow: 3,
arrows: true,
swipeToSlide: true,
focusOnSelect: true,
responsive: [
  {
    breakpoint: 1024,
    settings: {
      arrows: false,
      centerMode: true,
      slidesToShow: 1
    }
  },
  
]

});


/* Department and Program Page student testimonials slider */
$('.slick-media-slider').not('.slick-initialized').slick({
 centerMode: true,
slidesToShow: 3,
arrows: false,
swipeToSlide: true,
focusOnSelect: true,
dots: true,
responsive: [
  {
    breakpoint: 1024,
    settings: {
      arrows: false,
      centerMode: true,
      slidesToShow: 1,
      swipeToSlide: true,
      focusOnSelect: true,
    }
  },
  
]

});
   


});

